import styled, { css } from 'styled-components';


export const GridMenuOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export const GridMenuOptionItemContainer = styled.div<{isSelected:boolean}>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  font-weight: 500;
  font-size: 13px;
  line-height: 13px;
  text-align: center;
  /* letter-spacing: 0.03em; */

  padding: 10px 5px;

  width: 16.6%;

  cursor: pointer;

  & > img {
    border: 3px solid ${(props) => props.theme.colors.lightGray};
  }

  ${(props) => props.isSelected && css`
    & > img {
      border-color: ${(props) => props.theme.colors.backgroundBlack};
    }
  `}

  @media (max-height: ${(props) => props.theme.mediaQueryConstants.lowHeight}px) {
    padding-top: 5px;
    padding-bottom: 5px;
	}

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    width: 16.6%;
    
    padding-top: 0px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
	}
`;

export const GridMenuOptionImage = styled.img`
  width: 52px;
  height: 52px;

  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 10px;

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    margin-bottom: 4px;
  };
  
  @media (max-height: ${(props) => props.theme.mediaQueryConstants.lowHeight}px) {
    margin-bottom: 2px;
	};
`;